'use client';

import { type JSX, useEffect, useState } from 'react';

import { type IAssignmentEvent, init } from '@eppo/js-client-sdk';
import * as Sentry from '@sentry/nextjs';

import { Loader } from '@/_components';

interface IEppoRandomizationProvider {
  waitForInitialization?: boolean;
  children: JSX.Element;
  loadingComponent?: JSX.Element;
}

export default function EppoRandomizationProvider({
  waitForInitialization = true,
  children,
  loadingComponent = (
    <div className="flex size-full min-h-svh items-center justify-center">
      <Loader />
    </div>
  ),
}: IEppoRandomizationProvider): JSX.Element {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        await init({
          apiKey: process.env.NEXT_PUBLIC_EPPO_SDK_KEY ?? '',
          requestTimeoutMs: 3000,
          assignmentLogger: {
            logAssignment: async (assignment: IAssignmentEvent) => {
              await fetch('/api/bigQuery', {
                body: JSON.stringify(assignment),
                method: 'POST',
              });
            },
          },
        });
        setIsLoading(false);
      } catch (err) {
        Sentry.captureException(err);
        setIsLoading(false);
      }
    })();
  }, []);

  if (!waitForInitialization || !isLoading) return children;

  return loadingComponent;
}
